/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Esconde por completo as opcoes de variante que nao existem para a
  // combinacao atualmente selecionada, em vez de as mostrar visiveis mas
  // marcadas como indisponiveis. O tema ja adiciona a classe
  // "unavailable" ao <input> dessas opcoes sempre que a selecao muda
  // (ver assets/theme.js, classe "sellout").
  //
  // IMPORTANTE: so aplicamos isto a opcao "Boja" (Cor, data-option-position="2"
  // na Ogrlica Vecni Zagrljaj, apos a opcao "Dizajn" ter sido removida).
  var style = document.createElement('style');
  style.textContent = [
    '.selector-wrapper[data-option-position="2"] radio-swatch:has(input.unavailable),',
    '.selector-wrapper[data-option-position="2"] .radio__button:has(input.unavailable),',
    '.selector-wrapper[data-option-position="2"] .select-popout__item:has(a.unavailable) {',
    '  display: none !important;',
    '}'
  ].join('\n');
  document.head.appendChild(style);

  // A opcao "Ljubimac" (Pas/Macka, data-option-position="1") deve ficar
  // SEMPRE clicavel, mesmo quando a cor atualmente escolhida so existe
  // para o ljubimac atual. O CSS proprio do tema impede o clique
  // (pointer-events) em qualquer opcao marcada com a classe
  // "unavailable"/"sold-out". Garantimos aqui que essas classes NUNCA
  // chegam a ficar nos botoes de Ljubimac.
  function limparLjubimacIndisponivel() {
    document
      .querySelectorAll('.selector-wrapper[data-option-position="1"] input.unavailable, .selector-wrapper[data-option-position="1"] input.sold-out')
      .forEach(function (input) {
        input.classList.remove('unavailable', 'sold-out');
      });
  }

  limparLjubimacIndisponivel();

  var ljubimacObserver = new MutationObserver(function () {
    limparLjubimacIndisponivel();
  });

  ljubimacObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ['class'],
    childList: true,
    subtree: true
  });

  // Quando o cliente clica em "Pas" ou "Macka" e a cor atualmente
  // escolhida nao existe para esse ljubimac, salta automaticamente para
  // a primeira cor disponivel desse ljubimac.
  function obterProductJSON() {
    var script = document.querySelector('[data-product-json]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function chaveDaOpcao(product, nome) {
    if (!product || !product.options) return null;
    var idx = product.options.indexOf(nome);
    return idx === -1 ? null : 'option' + (idx + 1);
  }

  function saltarParaPrimeiraCorDisponivel(inputLjubimac) {
    var product = obterProductJSON();
    if (!product) return;

    var chaveLjubimac = chaveDaOpcao(product, 'Ljubimac');
    var chaveBoja = chaveDaOpcao(product, 'Boja');
    if (!chaveLjubimac || !chaveBoja) return;

    var novoLjubimac = inputLjubimac.value;
    var inputBojaAtual = document.querySelector('input[name^="options[Boja]"]:checked');
    var bojaAtual = inputBojaAtual ? inputBojaAtual.value : null;

    var combinacaoValida = product.variants.some(function (v) {
      return v[chaveLjubimac] === novoLjubimac && v[chaveBoja] === bojaAtual;
    });
    if (combinacaoValida) return;

    var candidatas = product.variants.filter(function (v) {
      return v[chaveLjubimac] === novoLjubimac;
    });
    if (!candidatas.length) return;

    var alvo = candidatas.filter(function (v) { return v.available; })[0] || candidatas[0];
    var bojaAlvo = alvo[chaveBoja];

    document.querySelectorAll('input[name^="options[Boja]"]').forEach(function (input) {
      if (input.value === bojaAlvo && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  document.addEventListener('change', function (e) {
    var alvo = e.target;
    if (alvo && alvo.matches && alvo.matches('input[name^="options[Ljubimac]"]')) {
      setTimeout(function () { saltarParaPrimeiraCorDisponivel(alvo); }, 0);
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
